import React, { useContext } from 'react'
import { AppContext } from '../context/app'
import Helmet from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'
import useAuth from '../hooks/useAuth'
import useRoute from '../hooks/useRoute'
import useNavigation from '../hooks/useNavigation'

import 'react-toastify/dist/ReactToastify.css'
import '../../semantic/dist/semantic.min.css'
import '../assets/fonts/proximanova_semibold_macroman/stylesheet.css'
import '../assets/fonts/proximanova_extrabold_macroman/stylesheet.css'

const Head = ({ lang, title }) => {
  const url = useRoute()
  const navigate = useNavigation()
  const { sessionId, endSession } = useContext(AppContext)

  useAuth(sessionId, endSession)

  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
          }
        }
      }
    `
  )

  if (!sessionId && url && url !== '/login') navigate('/login')

  return (
    <Helmet
      htmlAttributes={{
        lang
      }}
      title={title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
    >
      <link
        href="https://fonts.googleapis.com/css?family=Roboto&display=swap"
        rel="stylesheet"
      />
    </Helmet>
  )
}

export default Head
